import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { StateToObj } from "./reduxHelper";

const initialState = {
    
}
const update = (state,fromUserId) =>{
    const { data } =JSON.parse(JSON.stringify(state))
    const { fromUserId:fromUserIdDes } = fromUserId
    return   data.map((ele)=>{
        if(ele.fromUserId === fromUserIdDes){
            return{...ele,unreadCount : ele.unreadCount + 1}
        }else{
           return {...ele}
        } 
    })
}
const updateContact = (state,payload) =>{
    const { data } =JSON.parse(JSON.stringify(state))
    return [ ...data,payload ]
    /**
    // if(data.includes(payload)){
    //    return
    // }else{
    //     return data.push(payload)
    // }
    */
}
const readStatus = (state,payload) => {
    let { data } =JSON.parse(JSON.stringify(state))
    return data?.map((ele)=>{
        if(ele.fromUserId === payload){
            return { ...ele, unreadCount : 0 }
        }else{
            return {...ele}
         } 
    })
}  

const deleteCount = (unreadDataObj, currentData) => {
   return currentData.map((ele)=>{
        if(ele.fromUserId === unreadDataObj.fromUserId){
            return {
                ...ele,unreadCount:0 
            }
        }else{
            return{...ele}
        }
    })
}

const unreadCount = createSlice({
    name:'unreadCount',
    initialState,
    reducers:{
        addUnreadCount: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        },
        updateUnreadCount: (_state,payload)=>{
            return {
             "id" : uuidv4(),
             "data": update(_state,payload.payload)
            }
     },
     updateContactUnreadCount: (_state,payload)=>{
        return {
         "id" : uuidv4(),
         "data": updateContact(_state,payload.payload)
        }
     },
     updateReadStatus: (_state,payload)=>{
        return {
         "id" : uuidv4(),
         "data": readStatus(_state,payload.payload)
        }
     },
     unreadCountDelete: (_state,payload)=>{
         const { data } = StateToObj(_state)
        return {
         "id" : uuidv4(),
         "data": deleteCount(payload.payload,data)
        }
     }
    }
});

export default unreadCount.reducer
export const addUnreadCount = unreadCount.actions.addUnreadCount
export const updateUnreadCount = unreadCount.actions.updateUnreadCount
export const updateContactUnreadCount = unreadCount.actions.updateContactUnreadCount
export const updateReadStatus = unreadCount.actions.updateReadStatus
export const unreadCountDelete = unreadCount.actions.unreadCountDelete